import axiosService from "./services/axiosService";
import {ResponseDto} from "./pages/ResponseDto";

const API_AUTH_URL = process.env.REACT_APP_API_AUTH_URL;
const API_MAILER_URL = process.env.REACT_APP_API_MAILER_URL;
const API_APPS_URL = process.env.REACT_APP_API_APPS_URL;
const API_DPE_URL = process.env.REACT_APP_API_DPE_URL;


console.log('API_AUTH_URL:', API_AUTH_URL);
console.log('API_MAILER_URL:', API_MAILER_URL);
console.log('API_APPS_URL:', API_APPS_URL);
export const login = async (email: string, password: string) => {
    try {
        console.log('API_AUTH_URL:', API_AUTH_URL);
        const response = await axiosService.post(`${API_AUTH_URL}/api/authenticate`, {"username" : email, "password" : password });
        return response.data;
    } catch (error) {
        throw new Error('Erreur lors de la connexion');
    }
};

export const sendPasswordResetEmail = async (email: string) => {
    try {
        console.log('API_AUTH_URL:', API_AUTH_URL);

        // Envoi de l'email en tant que paramètre de requête
        const response = await axiosService.post(`${API_AUTH_URL}/api/auth/forgot-password`, null, {
            params: {
                email: email
            }
        });

        return response.data;
    } catch (error) {
        console.error('Erreur lors de l\'envoi de l\'email de réinitialisation :', error);
        throw new Error('Erreur lors de l\'envoi de l\'email de réinitialisation');
    }
};

export const signout = async () => {
    try {
        await axiosService.post(`${API_AUTH_URL}/api/signout`, {
            token: sessionStorage.getItem('tokenAdminUI'),
        });

    } catch (error) {
        throw new Error('Erreur lors de la déconnexion');
    }
};

export const getRoles = async () => {
    try {
        const token = sessionStorage.getItem('tokenAdminUI');
        const response = await axiosService.get(`${API_APPS_URL}/api/roles`,
            {
                headers: {
                    'Authorization': `Bearer ${token}`, // Ajouter le jeton d'authentification dans les en-têtes
                },
            });
        return response.data;
    } catch (error) {
        throw new Error('Erreur lors de la récupération des rôles');
    }
};

export const createRole = async (role: any) => {
    try {
        const token = sessionStorage.getItem('tokenAdminUI');
        const response = await axiosService.post(`${API_AUTH_URL}/api/roles`, role,
            {
                headers: {
                    'Authorization': `Bearer ${token}`, // Ajouter le jeton d'authentification dans les en-têtes
                },
            });
        return response.data;
    } catch (error) {
        throw new Error('Erreur lors de la création du rôle');
    }
};

export const updateRole = async (roleId: number, role: any) => {
    try {
        const token = sessionStorage.getItem('tokenAdminUI');
        const response = await axiosService.put(`${API_AUTH_URL}/api/roles/${roleId}`, role,
            {
                headers: {
                    'Authorization': `Bearer ${token}`, // Ajouter le jeton d'authentification dans les en-têtes
                },
            });
        return response.data;
    } catch (error) {
        throw new Error('Erreur lors de la mise à jour du rôle');
    }
};

export const deleteRole = async (roleId: number) => {
    try {
        const token = sessionStorage.getItem('tokenAdminUI');
        await axiosService.delete(`${API_AUTH_URL}/api/roles/${roleId}`,
            {
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            });
    } catch (error) {
        throw new Error('Erreur lors de la suppression du rôle');
    }
};

export const getUsers = async () => {
    try {
        const token = sessionStorage.getItem('tokenAdminUI');
        const response = await axiosService.get(`${API_AUTH_URL}/api/users`,
            {
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            });
        return response.data;
    } catch (error) {
        throw new Error('Erreur lors de la récupération des utilisateurs');
    }
};

export const createUser = async (user: any) => {
    try {
        const token = sessionStorage.getItem('tokenAdminUI');
        const response = await axiosService.post(`${API_AUTH_URL}/api/register`, user,
            {
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            });
        return response.data;
    } catch (error) {
        throw new Error('Erreur lors de la création de l\'utilisateur');
    }
};

export const updateUser = async (userId: number, user: any) => {
    try {
        const token = sessionStorage.getItem('tokenAdminUI');
        const response = await axiosService.put(`${API_AUTH_URL}/api/users/${userId}`, user,
            {
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            });
        return response.data;
    } catch (error) {
        throw new Error('Erreur lors de la mise à jour de l\'utilisateur');
    }
};

export const deleteUser = async (userId: number) => {
    try {
        const token = sessionStorage.getItem('tokenAdminUI');
        await axiosService.delete(`${API_AUTH_URL}/api/users/${userId}`,
            {
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            });
    } catch (error) {
        throw new Error('Erreur lors de la suppression de l\'utilisateur');
    }
};

export const getTemplateMailing = async () => {
    try {
        const token = sessionStorage.getItem('tokenAdminUI');
        const response = await axiosService.get(`${API_MAILER_URL}/api/templatemail`,
            {
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            });
        return response.data;
    } catch (error) {
        throw new Error('Erreur lors de la récupération des modèles de mail');
    }
};

export const createTemplateMailing = async (templateMailing: any) => {
    try {
        const token = sessionStorage.getItem('tokenAdminUI');
        const response = await axiosService.post(`${API_MAILER_URL}/api/templatemail`, templateMailing,
            {
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            });
        return response.data;
    } catch (error) {
        throw new Error('Erreur lors de la création du modèle de mail');
    }
};

export const updateTemplateMailing = async (templateMailingId: number, templateMailing: any) => {
    try {
        const token = sessionStorage.getItem('tokenAdminUI');
        const response = await axiosService.put(`${API_MAILER_URL}/api/templatemail/${templateMailingId}`, templateMailing,
            {
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            });
        return response.data;
    } catch (error) {
        throw new Error('Erreur lors de la mise à jour du modèle de mail');
    }
};

export const deleteTemplateMailing = async (templateMailingId: number) => {
    try {
        const token = sessionStorage.getItem('tokenAdminUI');
        await axiosService.delete(`${API_MAILER_URL}/api/templatemail/${templateMailingId}`,
            {
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            });
    } catch (error) {
        throw new Error('Erreur lors de la suppression du modèle de mail');
    }
};

export const getProspect = async () => {
    try {
        const token = sessionStorage.getItem('tokenAdminUI');
        const response = await axiosService.get(`${API_APPS_URL}/api/prospects`,
            {
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            });
        return response.data;
    } catch (error) {
        throw new Error('Erreur lors de la récupération des rôles');
    }
};

export const deleteProspect = async (prospectId: number) => {
    try {
        const token = sessionStorage.getItem('tokenAdminUI');
        await axiosService.delete(`${API_APPS_URL}/api/prospects/${prospectId}`,
            {
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            });
    } catch (error) {
        throw new Error('Erreur lors de la suppression du prospect');
    }
};

export const createProspect = async (prospect: any) => {
    try {
        const token = sessionStorage.getItem('tokenAdminUI');
        const response = await axiosService.post(`${API_APPS_URL}/api/prospects`, prospect,
            {
                headers: {
                    'Authorization': `Bearer ${token}`, // Ajouter le jeton d'authentification dans les en-têtes
                },
            });
        return response.data;
    } catch (error) {
        throw new Error('Erreur lors de la création du prospect');
    }
};

export const updateProspect = async (prospectId: number, prospect: any) => {
    try {
        const token = sessionStorage.getItem('tokenAdminUI');
        const response = await axiosService.put(`${API_APPS_URL}/api/prospects/${prospectId}`, prospect,
            {
                headers: {
                    'Authorization': `Bearer ${token}`, // Ajouter le jeton d'authentification dans les en-têtes
                },
            });
        return response.data;
    } catch (error) {
        throw new Error('Erreur lors de la mise à jour du prospect');
    }
};

export const getTypeAbaques = async () => {
    try {
        const token = sessionStorage.getItem('tokenAdminUI');
        const response = await axiosService.get<ResponseDto>(`${API_DPE_URL}/api/dpe/residentiel/type/dictionnaire`,
            {
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            });
        return response.data.data;
    } catch (error) {
        throw new Error('Erreur lors de la récupération des type d\'abaques');
    }
};

export const getAbaques = async (type : string) => {
    try {
        const token = sessionStorage.getItem('tokenAdminUI');
        const response = await axiosService.get<ResponseDto>(`${API_DPE_URL}/api/dpe/residentiel/abaques/` + type,
            {
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            });
        return response.data.data;
    } catch (error) {
        throw new Error('Erreur lors de la récupération des abaques');
    }
};

export const importeAbaqueData = async (file : File, selectedAbaqueType : string) => {
    try {
        if (!file || !selectedAbaqueType) {
            alert('Veuillez sélectionner un type d\'abaque et un fichier.');
            return;
        }

        const formData = new FormData();
        formData.append('file', file);

        const token = sessionStorage.getItem('tokenAdminUI');
        const response = await axiosService.post(`${API_DPE_URL}/api/dpe/residentiel/abaques/${selectedAbaqueType}/import`,formData,
            {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data'
                },
            });
        return response.data;
    } catch (error) {
        throw new Error('Erreur lors de la récupération des type d\'abaques');
    }
};